import { useMemo } from 'react'

import './style.scss'
import { AppFlex } from 'shared/ui/AppFlex/AppFlex'
import { AppTooltip } from 'UiKitComponents/AppTooltip'
import { MultiValueObjProps } from '../AppDropdown'

interface AppDropdownChooseItemsProps<T, TKey extends keyof T> {
  currentData: T[]
  multiValueObj: MultiValueObjProps | undefined
  propName?: TKey
  propValue?: TKey
  active: boolean
  onDeleteFromList?: (value: string | number) => void
  width?: number
}

export const AppDropdownChooseItems = <T, TKey extends keyof T>({
  currentData,
  active,
  propValue,
  propName,
  onDeleteFromList,
  multiValueObj,
  width,
}: AppDropdownChooseItemsProps<T, TKey>) => {
  const count = width ? Math.floor((width - 110) / 195) : 3
  const multiValueList: T[] = useMemo(
    () =>
      multiValueObj && currentData.length
        ? currentData
            .filter(
              (item) =>
                multiValueObj &&
                multiValueObj[propValue ? `${item[propValue]}` : `${item}`],
            )
            .reverse()
        : [],
    [currentData, multiValueObj, propValue],
  )
  if (!multiValueObj || !multiValueList.length || active) return null
  const onDeleteFromListHandler = (value: string | number) => () =>
    onDeleteFromList?.(value)
  const mainEl = [...multiValueList].splice(0, count)
  const secondEl =
    multiValueList.length > count
      ? [...multiValueList].slice(count, multiValueList.length)
      : []
  return (
    <AppFlex gap="12" className="chooseElementsWrap">
      {mainEl.slice(0, count).map((item) => (
        <AppFlex
          className="chooseElement"
          key={`${propValue ? item[propValue] : item}`}
          gap="4"
        >
          <span>{`${propName ? item[propName] : item}`}</span>
          <i
            className="an-ico an-ico-close"
            style={{ fontSize: '12px', color: '#242424' }}
            onClick={onDeleteFromListHandler(
              propValue ? (item[propValue] as number) : (item as string),
            )}
          />
        </AppFlex>
      ))}
      {secondEl.length > 0 && (
        <AppTooltip
          tooltipContent={
            <AppFlex gap="8" wrap>
              {secondEl.map((item) => (
                <AppFlex
                  className="chooseElement"
                  key={`${propValue ? item[propValue] : item}`}
                  gap="4"
                >
                  <span>{`${propName ? item[propName] : item}`}</span>
                  <div
                    className=""
                    onClick={onDeleteFromListHandler(
                      propValue
                        ? (item[propValue] as number)
                        : (item as string),
                    )}
                  >
                    <i
                      className="an-ico an-ico-close"
                      style={{ fontSize: '12px', color: '#242424' }}
                      onClick={onDeleteFromListHandler(
                        propValue
                          ? (item[propValue] as number)
                          : (item as string),
                      )}
                    />
                  </div>
                </AppFlex>
              ))}
            </AppFlex>
          }
        >
          <div className="extraDiv">Ещё +{secondEl.length}</div>
        </AppTooltip>
      )}
    </AppFlex>
  )
}
